module.exports = __webpack_public_path__ + "static/media/2. Arbusto, Base, Resina cristal, 30 x 50 x 5 cm, 2019.JPG copy.2c2acbca.png";